import { FlowBlockHeadline as HeadlineBlockModel } from '@staffino/model';

export default function headlineBlockProps(block: HeadlineBlockModel) {
  return {
    fontSize: block.size === 'small' ? '1.25rem' : '2rem',
  };
}
